export default "__VITE_ASSET__00926b2a__"